// LeaveDetails.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const LeaveDetails = () => {
  const [leaveRecords, setLeaveRecords] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token") || "YOUR_FALLBACK_TOKEN";
    const config = { headers: { Authorization: `Bearer ${token}` } };

    axios
      .get("https://attendanceapi.gensparc.com/leave/allleavelist", config)
      .then((response) => {
        let records = response.data;
        // If the API wraps the data array in another property, adjust accordingly.
        if (!Array.isArray(records) && records.data) {
          records = records.data;
        }
        console.log("All Leave Records:", records);

        // Use moment to get today's date (startOf day for consistency)
        const today = moment().startOf("day");
        // Filter records where today is between start_date and end_date (inclusive)
        const filteredRecords = records.filter((record) => {
          if (!record.start_date || !record.end_date) return false;
          const startDate = moment(record.start_date).startOf("day");
          const endDate = moment(record.end_date).startOf("day");
          return today.isBetween(startDate, endDate, null, "[]");
        });

        console.log("Filtered Leave Records for Today:", filteredRecords);
        setLeaveRecords(filteredRecords);
      })
      .catch((error) =>
        console.error("Error fetching leave records:", error)
      );
  }, []);
  const handleBackClick = () => {
    navigate("/dashboard");
  };

  return (
    <Box sx={{ padding: 4, backgroundColor: "#fafafa", minHeight: "100vh" }}>
      <Box display="flex" alignItems="center" marginBottom={3}>
        <IconButton onClick={handleBackClick} aria-label="back" sx={{marginTop:10}}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ flexGrow: 1, textAlign: "center", marginTop:10 }}
        >
          Leave Details for Today
        </Typography>
        </Box>
      {leaveRecords.length > 0 ? (
        <TableContainer component={Paper} sx={{ maxWidth: 800, margin: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Employee Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Leave Type
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Start Date
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  End Date
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Days
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaveRecords.map((record) => (
                <TableRow key={record.id}>
                  <TableCell>{record.employee_name}</TableCell>
                  <TableCell>{record.leave_type}</TableCell>
                  <TableCell>
                    {moment(record.start_date).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>
                    {moment(record.end_date).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>{record.days}</TableCell>
                  <TableCell>{record.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" align="center">
          No leave records for today.
        </Typography>
      )}
    </Box>
  );
};

export default LeaveDetails;
